import { render, staticRenderFns } from "./myBidTable.vue?vue&type=template&id=6b5d16db"
import script from "./myBidTable.vue?vue&type=script&lang=js"
export * from "./myBidTable.vue?vue&type=script&lang=js"
import style0 from "./myBidTable.vue?vue&type=style&index=0&id=6b5d16db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports